import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FiFacebook } from "react-icons/fi";
import { BsTwitterX } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { RiYoutubeLine } from "react-icons/ri";
import { FaArrowUp } from "react-icons/fa";


const LEGAL_LINK_STATE_FROM_LANDING = { fromLanding: true };

type FooterProps = {
  fromLanding?: boolean;
};

const Footer = ({ fromLanding = false }: FooterProps) => {
  const legalState = fromLanding ? LEGAL_LINK_STATE_FROM_LANDING : undefined;
    const currentYear = new Date().getFullYear();
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        setShowScrollTop(window.scrollY > 150);
      };

      window.addEventListener("scroll", handleScroll);
      handleScroll();

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    useEffect(() => {
      const hideDarkFilter = () => {
        const darkFilter = document.querySelector(".onetrust-pc-dark-filter") as HTMLElement | null;
        if (darkFilter) {
          darkFilter.style.display = "none";
        }
      };

      const pcObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          const target = mutation.target as HTMLElement;
          if (
            target.id === "onetrust-pc-sdk" &&
            (target.style.display === "none" || target.getAttribute("aria-hidden") === "true")
          ) {
            hideDarkFilter();
          }
        }
      });

      const bannerObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          const target = mutation.target as HTMLElement;
          if (
            target.id === "onetrust-banner-sdk" &&
            target.style.display === "none"
          ) {
            hideDarkFilter();
          }
        }
      });

      const attachObservers = () => {
        const pcSdk = document.getElementById("onetrust-pc-sdk");
        if (pcSdk) {
          pcObserver.observe(pcSdk, { attributes: true, attributeFilter: ["style", "aria-hidden"] });
        }
        const bannerSdk = document.getElementById("onetrust-banner-sdk");
        if (bannerSdk) {
          bannerObserver.observe(bannerSdk, { attributes: true, attributeFilter: ["style"] });
        }
      };
      const bodyObserver = new MutationObserver(() => {
        attachObservers();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      attachObservers();

      return () => {
        pcObserver.disconnect();
        bannerObserver.disconnect();
        bodyObserver.disconnect();
      };
    }, []);

    const handleScrollTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
      <>
        {showScrollTop && (
          <button
            type="button"
            onClick={handleScrollTop}
            aria-label="Scroll to top"
            className="fixed bottom-28 right-5 z-40 rounded-full flex items-center justify-center"
            style={{ width: "36px", height: "36px", backgroundColor: "#191919" }}
          >
            <FaArrowUp size={14} className="text-white" />
          </button>
        )}
        <footer className="px-5 py-3 bg-black text-white ">
          {/* OneTrust cookies settings button */}
          <div className="flex justify-end w-full pb-3 border-b border-gray-700 mb-3">
            <button
              id="ot-sdk-btn"
              className="ot-sdk-show-settings font-semibold bg-transparent border-none cursor-pointer text-sm"
              style={{ color: "#86BC25" }}
            >
              Cookie settings
            </button>
          </div>

          <div className="md:hidden">
            <div className="flex items-center justify-between gap-3 flex-col">
              <div className="text-xs text-left">Copyright © {currentYear} Deloitte Shared Services India LLP</div>
              <ul className="flex items-center gap-3">
                <li><NavLink target="_blank" to='https://www.facebook.com/DeloitteIndia/'><FiFacebook size={16}/></NavLink></li>
                <li><NavLink target="_blank" to='https://x.com/DeloitteIndia'><BsTwitterX size={14}/></NavLink></li>
                <li><NavLink target="_blank" to='https://www.linkedin.com/company/deloitte/posts/?feedView=all'><FaLinkedinIn size={15}/></NavLink></li>
                <li><NavLink target="_blank" to='https://www.instagram.com/deloitteindia/?hl=en'><FiInstagram  size={16}/></NavLink></li>
                <li><NavLink target="_blank" to='https://www.youtube.com/user/INDeloitte'><RiYoutubeLine size={20}/></NavLink></li>
              </ul>
            </div>
            <ul className="mt-3 flex items-center gap-4 font-semibold md:justify-start justify-center flex-wrap">
              <li><NavLink to='/disclaimer' state={legalState} className='font-semibold underline'>Disclaimer</NavLink></li>
              <li><NavLink to='/terms-of-use' state={legalState} className='font-semibold underline'>Terms of use</NavLink></li>
              <li><NavLink to='/privacy-policy' state={legalState} className='font-semibold underline'>Privacy policy</NavLink></li>
            </ul>
          </div>

          <div className="hidden md:flex md:justify-between items-center md:flex-row gap-y-3">
            <div className="flex gap-2 md:flex-row flex-col">
              <div className="md:text-sm text-xs! mr-5 md:text-right text-center">
                Copyright © {currentYear} Deloitte Shared Services India LLP
              </div>
              <ul className="flex items-center gap-4 font-semibold">
                <li><NavLink to='/disclaimer' state={legalState} className='font-semibold underline'>Disclaimer</NavLink></li>
                <li><NavLink to='/terms-of-use' state={legalState} className='font-semibold underline'>Terms of use</NavLink></li>
                <li><NavLink to='/privacy-policy' state={legalState} className='font-semibold underline'>Privacy policy</NavLink></li>
              </ul>
            </div>
            <ul className="flex items-center gap-4">
              <li><NavLink target="_blank" to='https://www.facebook.com/DeloitteIndia/'><FiFacebook size={20}/></NavLink></li>
              <li><NavLink target="_blank" to='https://x.com/DeloitteIndia'><BsTwitterX size={19}/></NavLink></li>
              <li><NavLink target="_blank" to='https://www.linkedin.com/company/deloitte/posts/?feedView=all'><FaLinkedinIn size={20}/></NavLink></li>
              <li><NavLink target="_blank" to='https://www.instagram.com/deloitteindia/?hl=en'><FiInstagram  size={20}/></NavLink></li>
              <li><NavLink target="_blank" to='https://www.youtube.com/user/INDeloitte'><RiYoutubeLine size={25}/></NavLink></li>
            </ul>
          </div>
          {/* <div>
            <p>For questions, concerns, or feedback, please contact admin@deloitte.com</p>
            <p className="text-[#BBBCBC] text-xs mt-1 mb-2">
              Deloitte refers to one or more of Deloitte Touche Tohmatsu Limited (“DTTL”), its global network of member firms, and their related entities (collectively, the “Deloitte organization”). DTTL (also referred to as “Deloitte Global”) and each of its member firms and related entities are legally separate and independent entities, which cannot obligate or bind each other in respect of third parties. DTTL and each DTTL member firm and related entity is liable only for its own acts and omissions, and not those of each other. DTTL does not provide services to clients. Please see www.Deloitte.com/about to learn more.
            </p>
            <p className="text-[#BBBCBC] text-xs mt-1 mb-2">
              © {currentYear} For information, contact Deloitte Global.
            </p>
          </div> */}
        </footer>
      </>
    )
}

export default Footer